module.exports = __webpack_public_path__ + "img/20190717164251193.c2b648e3.png";